import {useRef} from 'react';

/**
 * Custom React hook that manages scroll-based anchor routing behavior by observing a DOM element's visibility.
 * This hook tracks whether the referenced element is in the viewport using an intersection observer. Once the element
 * is in view and the route change is considered complete, it updates the router path to reflect the anchor if necessary.
 * It ensures the scroll position is preserved and the route update is shallow to avoid unnecessary re-renders.
 *
 * @returns An object containing a `ref` which should be attached to the target DOM element to be observed.
 *
 * @example
 * ```tsx
 * const {ref} = useScrollAnchorWrapper('#section1');
 *
 * return <div ref={ref}>Anchored Section</div>;
 * ```
 */
export const useScrollAnchorWrapper = () => {
    const ref = useRef<HTMLDivElement>(null);

    return {ref};
};